import { useEffect,useState } from 'react'
import { post } from '../../utils/axios'
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const Faq = () => {

    const [faq,setFaq] = useState([])
    const [expanded,setExpanded] = useState(false)
    
    useEffect(() => {
        post('Faq/GetFaq').then(({ data }) => {
            if(data.isSuccess)
                setFaq(data.data)
        })
    },[])

    const handleChange = panel => (event,isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    }

    return (
        <Grid item px={0.3}>
            <h3 className="others-page-title">سوالات متداول</h3>
            <div className="safe-area">
                <Box sx={{mb: 5}}>
                    {faq.map((f,index) => <Accordion expanded={expanded === `faq-${index}`} onChange={handleChange(`faq-${index}`)}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography sx={{ width: '66%', flexShrink: 0,fontSize: 14 }}>{f.question}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography sx={{fontSize: 13}}>{f.answer}</Typography>
                        </AccordionDetails>
                    </Accordion>)}
                </Box>
            </div>
        </Grid>
    )
}

export default Faq